export function getTransferredState(key) {
    return typeof window !== 'undefined' ? window[key] : undefined;
}
